export default class Collection {
  _id = ""

  /**
   * Create an object from data
   */
  constructor(data, filter) {
    data && this.hydrate(data, filter)
  }

  /**
   * Enumerate the fields of the object and return
   * in a simple object. Handles nested collections
   *
   * @returns
   */
  toPlainObject = () => {
    const data = {}
    const collection = this
    for (const key of Object.keys(this)) {
      const e = collection[key]
      if (typeof e !== "function") {
        data[key] = e instanceof Collection ? e.toPlainObject() : e
      }
    }

    return data
  }

  /**
   * Hydrate the data into the object. Filter as needed
   * if a function is specified
   *
   * @param data
   * @param filter
   */
  hydrate = (data, filter = (k, e) => e) => {
    const collection = this
    for (const key in data) {
      const e = filter(key, data[key])
      if (e) {
        collection[key] = e
      }
    }

    return this
  }

  /**
   * Return clone of this object
   * 
   * @returns clone
   */
  clone = () => {
    return Object.create(this)
  }
}
